import { Box, Typography } from '@material-ui/core'

export const SubTitle = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <Box paddingBottom={1}>
    <Typography variant="h5">{children}</Typography>
  </Box>
)
